import { Form, Formik } from "formik";
import React from "react";
import { useTranslation } from "react-i18next";
import {
  generateSearchFormItem,
  getGameTreeData,
} from "../../../../../utils/helper";
import { SearchAccordion } from "../../../../common";
import { defaultFilter, ISearchProps } from "./type";

const Search = ({ filter, setFilter, popup, gameInfos }: ISearchProps) => {
  const { t, i18n } = useTranslation();

  return (
    <SearchAccordion>
      <Formik
        enableReinitialize={true}
        initialValues={filter}
        onSubmit={(values, { setSubmitting }) => {
          setFilter({ ...values, pages: 0 });
          setSubmitting(false);
        }}
      >
        {(form) => (
          <Form style={{ width: "100%" }}>
            {generateSearchFormItem(
              form,
              [
                {
                  type: "time",
                  name: "time",
                  label: "common.Time",
                },
                {
                  type: "text",
                  name: "transactionID",
                  label: "ClubCompetitiveGameRecord.transactionID",
                  disable: Boolean(
                    form.values.fakeID !== "" || form.values.gameIDs?.length
                  ),
                },
                {
                  type: "multiSelect",
                  name: "gameIDs",
                  label: "ClubCompetitiveGameRecord.gameID",
                  treeData: getGameTreeData(gameInfos, i18n.language),
                  disable: form.values.transactionID !== "",
                },
                {
                  type: "number",
                  name: "fakeID",
                  label: "ClubCompetitiveGameRecord.fakeID",
                  disable: form.values.transactionID !== "",
                },
                {
                  type: "number",
                  name: "clubsID",
                  disable: form.values.transactionID !== "",
                  label: "ClubElectronicGameRecord.clubID",
                },
              ].filter((v) => {
                return !popup || v.name !== "playerID";
              }) as any,
              defaultFilter(),
              t
            )}
          </Form>
        )}
      </Formik>
    </SearchAccordion>
  );
};

export default Search;
